import Vue from 'vue'
import Vuex from 'vuex'

import {alert} from './alert'
import {authentication} from './authentication'
import {users} from './user'
import {download} from './download'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    alert,
    authentication,
    users,
    download
  }
})



// WEBPACK FOOTER //
// ./src/_store/index.js